<template>
    <section class="PerformancePreviewFileDialog">
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-click-modal="false"
            :close-on-press-escape="flag"
            :destroy-on-close="true"
            :width="width"
            :before-close="hide"
            :custom-class="'PerformancePreviewFileDialog'"
        >
        <div v-if="srcList.length > 0">
            <div class="updateUserInfo">
                <span>{{ updateUserName }}</span
                >在<span>{{ updateTime }}</span
                >上传
            </div>
            <div class="img-content" style="height: 500px">
                <ul id="viewers" style="display: none" v-if="dialogVisible">
                    <li v-for="(item, index) in srcList" :key="index">
                        <img :src="item" />
                    </li>
                </ul>
            </div>
        </div>
        <div v-else class="no-file-data">
            <p>暂 无 附 件 数 据</p>
        </div>
        </el-dialog>
    </section>
</template>
<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
export default {
    name: 'PerformanceCommonDialog',
    props: {
        title: {
            type: String,
            default: '附件预览'
        },
        width: {
            type: String,
            default: '750px'
        },
        attachmentList: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            dialogVisible: false,
            updateUserName: '',
            updateTime: '',
            viewer: {},
            flag: true,
            srcList: []
        };
    },
    methods: {
        /**
         * @description 切换图片时，更新图片上传信息
         * @param 当前显示图片索引
         */
        updateInfo (index) {
            this.updateUserName = this.attachmentList[index].updateUserName;
            this.updateTime = this.attachmentList[index].updateTime;
        },
        // 初始化viewer插件
        initViewer () {
            if (this.srcList.length > 0) {
                this.viewer = new Viewer(document.getElementById('viewers'), {
                    inline: true,
                    navbar: false,
                    backdrop: true, // 透明背景色
                    zoomOnWheel: true, // 滚动缩放
                    viewed: data => { // 图片加载完成时回调
                        this.updateInfo(data.detail.index);
                    }
                });
            }
        },
        // 关闭弹窗
        hide () {
            this.dialogVisible = false;
        },
        /**
         * @description: 判断键盘事件 实现逐级退出功能
         * @return {*}
         */
        keyDown () {
            document.onkeydown = e => {
                if (e.code === 'Escape') {
                    this.flag = !(e.target.className === 'viewer-button viewer-fullscreen viewer-fullscreen-exit');
                }
            };
        },
        // 显示弹窗
        show () {
            this.srcList = this.attachmentList.map(v => v.path);
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.keyDown();
                this.initViewer();
            });
        }
    }
};
</script>
<style lang="less">
.PerformancePreviewFileDialog {
    .el-dialog__body {
        text-align: center;

        .updateUserInfo {
            line-height: 30px;
            font-size: 14px;

            > span {
                margin: 0 5px;
            }
        }

        .viewer-title {
            color: #000;
        }

        .no-file-data {
            display: flex;
            min-height: 300px;
            align-items: center;
            justify-content: center;
            font-size: 14px;
        }
    }
}
</style>
